var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.1,
    height: 42,
    viewBox: "0 0 42.1 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_102",
    x: 12.7,
    y: 0.3,
    width: 29.4,
    height: 29.4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_103",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RULE",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_102)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_102-2",
    "data-name": "Pfad 102",
    className: "cls-1",
    d: "M29.7.3l-17,17,6.4,6.4,17-17Zm4.9,6.3L19,22.2l-4.9-4.9,2-2L19,18.2l.7-.7-2.9-2.9,2-2,1.7,1.7.7-.7-1.7-1.7,2-2,2.9,2.9.7-.7L22.2,9.2l2-2L26,8.9l.7-.7L25,6.5l2-2,2.9,2.9.7-.7L27.7,3.8l2-2Z",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_103)",
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_103-2",
    "data-name": "Pfad 103",
    fill: "#f5f5f5",
    d: "M34,17.8V18A16,16,0,1,1,18,2V0A18,18,0,1,0,36,18v-.2Z",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRule);
export default __webpack_public_path__ + "static/media/rule.30d769adea72a11893786c99c1ad8e9b.svg";
export { ForwardRef as ReactComponent };